import { render, staticRenderFns } from "./listThree.vue?vue&type=template&id=35b0d979&scoped=true"
import script from "./listThree.vue?vue&type=script&lang=js"
export * from "./listThree.vue?vue&type=script&lang=js"
import style0 from "./listThree.vue?vue&type=style&index=0&id=35b0d979&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b0d979",
  null
  
)

export default component.exports